import {App} from 'vue';
import mdiVue from 'mdi-vue/v3';
import * as mdijs from '@mdi/js';
import {customIcons} from '../icons/custom';
import {ZiggyVue} from 'ziggy-js';
import {createStembleI18n} from './create-stemble-i18n';

/**
 * Registers the plugins a design-system component needs in order to render:
 * i18n (`useI18n`/`t`), Ziggy (`route()`), and MDI icons (the global `<mdicon>`).
 *
 * This is the single source of truth shared between the full app entry
 * (`app.ts`) and the lightweight design-system playground preview entry
 * (`design-preview.ts`). Keeping it in one place ensures the playground can't
 * silently drift from how the app registers the component-rendering plugins —
 * anything the app adds on top (the Inertia plugin, highlight.js) stays explicit
 * at the call site.
 */
export function registerDesignSystemPlugins(
  app: App,
  i18n: ReturnType<typeof createStembleI18n>
): App {
  return app
    .use(i18n)
    .use(ZiggyVue)
    .use(mdiVue as any, {icons: {...mdijs, ...customIcons}});
}
